import React from 'react';
import ReactDOM from 'react-dom/client';
import "reset-css"
import "@/index.scss"
import Main from './main';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>
);

